// Axis Version Configuration
// Update this file with each release

export const APP_NAME = 'Axis';
export const APP_TAGLINE = 'Where Operations Align';
export const APP_VERSION = '1.0.0';
export const BUILD_DATE = '2025-01-06';

// Service brand
export const SERVICE_NAME = 'CoreOps';
export const SERVICE_TAGLINE = 'Powering Facility Excellence.';

// Parent company
export const COMPANY_NAME = "Lazy E Holdings LLC";

// Version history
export const CHANGELOG = [
  {
    version: '1.0.0',
    date: '2025-01-06',
    changes: [
      'Initial release of Axis platform',
      'Renamed from Facility Flow to Axis',
      'Updated branding with warm amber theme',
      'Multi-tenant architecture',
      'Universal property type support',
      '9 user roles with RBAC',
      'Work order management',
      'Asset tracking',
      'Vendor management',
      'Occupant portal',
    ],
  },
];

// Feature flags for version-gated features
export const FEATURES = {
  inAppMessaging: false, // v1.1.0
  realtimeUpdates: false, // v1.1.0
  pwa: false, // v1.2.0
  iotLiveData: false, // v1.3.0
  aiPhoneIntake: false, // v1.3.0 - AI-powered tenant phone line (Bland AI / Vapi integration)
  developerPortal: false, // v2.0.0
};

// AI Phone Integration Notes (for v1.3.0 implementation):
// - Platforms: Bland AI (~$0.09/min), Vapi (~$0.05/min), Retell AI, Synthflow
// - Database additions needed:
//   - tenants.phone_number (indexed for fast lookup)
//   - tenants.phone_verified
//   - properties.ivr_keypad_number (for phone menu selection)
//   - work_orders.source ('portal' | 'phone_ai' | 'email' | 'manual')
//   - work_orders.ai_transcript (optional call summary)
// - API endpoint: GET /api/tenants/lookup?phone=+14695551234
